import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface GeminiBatchJob {
    id: number;
    jobName: string;
    levelId: number;
    levelDisplayName: string;
    keywordCount: number;
    status: string;
    kind: string;
    provider?: string;
    resultsFileName?: string;
    errorMessage?: string;
    createdAt: string;
    lastCheckedAt?: string;
    completedAt?: string;
    resultsFetchedAt?: string;
}

@Injectable({
    providedIn: 'root'
})
export class GeminiBatchService {
    private apiUrl = `${environment.apiUrl}/Gemini`;

    constructor(private http: HttpClient) {}

    startBatchForLevel(levelId: number, kind: string = 'Question'): Observable<GeminiBatchJob> {
        return this.http.post<GeminiBatchJob>(`${this.apiUrl}/batch-for-level?levelId=${levelId}&kind=${kind}`, {});
    }

    getJobs(): Observable<GeminiBatchJob[]> {
        return this.http.get<GeminiBatchJob[]>(`${this.apiUrl}/jobs`);
    }

    checkStatus(jobId: number): Observable<GeminiBatchJob> {
        return this.http.post<GeminiBatchJob>(`${this.apiUrl}/jobs/${jobId}/check-status`, {});
    }

    fetchResults(jobId: number): Observable<{ updatedCount: number }> {
        return this.http.post<{ updatedCount: number }>(`${this.apiUrl}/jobs/${jobId}/fetch-results`, {});
    }
}
